var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_41293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4587 20.2841C11.4944 20.2841 11.5301 20.2805 11.5659 20.2752L14.5694 19.7484C14.6051 19.7412 14.6391 19.7252 14.6641 19.6984L22.2337 12.1287C22.2503 12.1122 22.2634 12.0926 22.2724 12.071C22.2813 12.0494 22.2859 12.0262 22.2859 12.0028C22.2859 11.9794 22.2813 11.9563 22.2724 11.9347C22.2634 11.9131 22.2503 11.8935 22.2337 11.8769L19.2659 8.9073C19.2319 8.87337 19.1873 8.85552 19.1391 8.85552C19.0909 8.85552 19.0462 8.87337 19.0123 8.9073L11.4426 16.4769C11.4159 16.5037 11.3998 16.5359 11.3926 16.5716L10.8659 19.5752C10.8485 19.6708 10.8547 19.7693 10.8839 19.862C10.9132 19.9547 10.9646 20.0389 11.0337 20.1073C11.1516 20.2216 11.2998 20.2841 11.4587 20.2841ZM12.6623 17.1698L19.1391 10.6948L20.448 12.0037L13.9712 18.4787L12.3837 18.7591L12.6623 17.1698ZM22.5712 21.7841H9.42836C9.11229 21.7841 8.85693 22.0394 8.85693 22.3555V22.9984C8.85693 23.0769 8.92122 23.1412 8.99979 23.1412H22.9998C23.0784 23.1412 23.1426 23.0769 23.1426 22.9984V22.3555C23.1426 22.0394 22.8873 21.7841 22.5712 21.7841Z",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_41293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.91e77cfc5aab146707026c5510fe21c8.svg";
export { ForwardRef as ReactComponent };